// MOCK DATA — Vexent Wire News Platform
// Replace with backend API integration later per contracts.md

export const SITE = {
  name: "Vexent Wire",
  tagline: "Financial Intelligence & Research",
  motto: "Independent research and educational insights for informed readers.",
  founded: 2001,
};

export const CATEGORIES = [
  { slug: "markets",          label: "Markets",          color: "#0B1F33" },
  { slug: "commodities",      label: "Commodities",      color: "#7a3a1c" },
  { slug: "precious-metals",  label: "Precious Metals",  color: "#B8E9F1" },
  { slug: "macro",            label: "Macro",            color: "#2a4a3e" },
  { slug: "policy",           label: "Policy",           color: "#3a2c5a" },
  { slug: "geopolitics",      label: "Geopolitics",      color: "#7a1c1c" },
  { slug: "geopolitical-intrigue", label: "Geopolitical Intrigue Worldwide", color: "#5a1420" },
  { slug: "personal-finance", label: "Personal Finance", color: "#1c4a6e" },
  { slug: "commentary",       label: "Commentary",       color: "#4a3222" },
  { slug: "strategy",         label: "Strategy",         color: "#0e4a3c" },
  { slug: "research",         label: "Research",         color: "#0B1F33" },
  // Legacy slugs retained so existing articles keep resolving
  { slug: "metals",           label: "Metals",           color: "#B8E9F1" },
  { slug: "geopolitical",     label: "Geopolitical",     color: "#7a1c1c" },
  { slug: "economics",        label: "Economics",        color: "#2a4a3e" },
  { slug: "politics",         label: "Politics",         color: "#3a2c5a" },
  { slug: "science-tech",     label: "Science & Technology", color: "#1c4a6e" },
  { slug: "off-planet",       label: "Off Planet",       color: "#0d1a3e" },
  { slug: "innovation",       label: "Innovation",       color: "#5a3a1e" },
  { slug: "money-ideas",      label: "Money Ideas",      color: "#0e4a3c" },
];

export const TICKER = [
  { symbol: "GOLD", price: 2418.55, change: +12.30 },
  { symbol: "SILVER", price: 30.85, change: +0.42 },
  { symbol: "S&P 500", price: 5537.02, change: -18.44 },
  { symbol: "DJIA", price: 39420.11, change: -62.10 },
  { symbol: "NASDAQ", price: 18188.30, change: -33.02 },
  { symbol: "10Y YIELD", price: 4.312, change: +0.041 },
  { symbol: "DXY", price: 105.02, change: -0.19 },
  { symbol: "BTC", price: 62410, change: +780 },
  { symbol: "WTI", price: 82.44, change: +1.02 },
  { symbol: "COPPER", price: 4.485, change: -0.03 },
];

const IMG = {
  markets1: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?crop=entropy&cs=srgb&fm=jpg&q=85",
  markets2: "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?crop=entropy&cs=srgb&fm=jpg&q=85",
  markets3: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=jpg&q=85",
  markets4: "https://images.unsplash.com/photo-1707761918029-1295034aa31e?crop=entropy&cs=srgb&fm=jpg&q=85",
  markets5: "https://images.pexels.com/photos/102152/pexels-photo-102152.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  markets6: "https://images.pexels.com/photos/534216/pexels-photo-534216.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  gold1: "https://images.unsplash.com/photo-1610375461369-d613b564f4c4?crop=entropy&cs=srgb&fm=jpg&q=85",
  gold2: "https://images.unsplash.com/photo-1610375461246-83df859d849d?crop=entropy&cs=srgb&fm=jpg&q=85",
  gold3: "https://images.pexels.com/photos/8442352/pexels-photo-8442352.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  gold4: "https://images.pexels.com/photos/8442328/pexels-photo-8442328.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  geo1: "https://images.unsplash.com/photo-1589262804704-c5aa9e6def89?crop=entropy&cs=srgb&fm=jpg&q=85",
  geo2: "https://images.unsplash.com/photo-1621977717126-e29965156a27?crop=entropy&cs=srgb&fm=jpg&q=85",
  geo3: "https://images.unsplash.com/photo-1772299399188-0139d5740004?crop=entropy&cs=srgb&fm=jpg&q=85",
  geo4: "https://images.unsplash.com/photo-1772308260508-0d52aad2e8dd?crop=entropy&cs=srgb&fm=jpg&q=85",
  geo5: "https://images.unsplash.com/photo-1556122492-766a8b354a16?crop=entropy&cs=srgb&fm=jpg&q=85",
  // Additional editorial covers (broad topics)
  fed1: "https://images.unsplash.com/photo-1633059050703-0f1b50828402?crop=entropy&cs=srgb&fm=jpg&q=85",
  fed2: "https://images.unsplash.com/photo-1581970559652-65c906087a82?crop=entropy&cs=srgb&fm=jpg&q=85",
  oil1: "https://images.unsplash.com/photo-1516937941344-00b4e0337589?crop=entropy&cs=srgb&fm=jpg&q=85",
  oil2: "https://images.unsplash.com/photo-1588011930968-eadac80e6a5a?crop=entropy&cs=srgb&fm=jpg&q=85",
  oil3: "https://images.unsplash.com/photo-1516199423456-1f1e91b06f25?crop=entropy&cs=srgb&fm=jpg&q=85",
  chip1: "https://images.unsplash.com/photo-1592659762303-90081d34b277?crop=entropy&cs=srgb&fm=jpg&q=85",
  chip2: "https://images.unsplash.com/photo-1562408590-e32931084e23?crop=entropy&cs=srgb&fm=jpg&q=85",
  crypto1: "https://images.unsplash.com/photo-1605792657660-596af9009e82?crop=entropy&cs=srgb&fm=jpg&q=85",
  crypto2: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?crop=entropy&cs=srgb&fm=jpg&q=85",
  floor1: "https://images.unsplash.com/photo-1761233138997-44d9b002a08f?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const COVER_LIBRARY = [
  "https://images.unsplash.com/photo-1633059050703-0f1b50828402?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1581970559652-65c906087a82?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1516937941344-00b4e0337589?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1588011930968-eadac80e6a5a?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1516199423456-1f1e91b06f25?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1592659762303-90081d34b277?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1562408590-e32931084e23?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1605792657660-596af9009e82?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?crop=entropy&cs=srgb&fm=jpg&q=85",
  "https://images.unsplash.com/photo-1761233138997-44d9b002a08f?crop=entropy&cs=srgb&fm=jpg&q=85",
];

export const AUTHORS = [
  { id: "mf", name: "Max Fischer", role: "", photo: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", bio: "" },
];

export const MAX_PHOTO = "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?crop=entropy&cs=srgb&fm=jpg&q=85&w=800";

const LOREM = `The market's reaction was swift and revealing. In the hours following the announcement, capital flows suggested that institutional players had positioned themselves well in advance — a pattern we've documented repeatedly in our research letters. Retail participants, by contrast, appear caught on the wrong side of what may prove to be a structural inflection point.\n\nWhat we are witnessing is not merely a cyclical adjustment. The underlying architecture of global finance is being reconfigured in real time, and the incentives that governed the last decade of monetary policy no longer apply cleanly. Central banks now face a trilemma with no elegant exit: defend the currency, sustain asset prices, or stabilize the real economy. They cannot do all three.\n\nOur working thesis remains that hard assets — gold, silver, productive land, and select energy infrastructure — will continue to attract disproportionate capital as counterparty risk is repriced across the system. The question for readers is not whether to prepare, but how quickly. Historical parallels to 1971, 1979, and 2008 all point in the same direction, though the mechanism this time may be more diffuse and less spectacular than prior episodes.\n\nWe caution subscribers against extrapolating short-term price action into long-term conclusions. Volatility is the price of admission, and the most consequential moves rarely announce themselves in advance. Position sizing, patience, and a clear understanding of one's own time horizon remain the most underrated tools in any serious investor's kit.`;

export const ARTICLES = [
  {
    id: "a1",
    slug: "the-quiet-repricing-of-sovereign-risk",
    title: "The Quiet Repricing of Sovereign Risk",
    dek: "Bond markets are whispering what politicians refuse to say aloud — the term premium is back, and this time it may be permanent.",
    category: "markets",
    author: "mf",
    image: IMG.markets1,
    publishedAt: "2025-07-04T09:20:00Z",
    readTime: 8,
    featured: true,
    tags: ["Bonds", "Fed", "Term Premium"],
    audio: "https://cdn.pixabay.com/download/audio/2022/03/15/audio_7d76e3a0e5.mp3?filename=corporate-uplifting-motivational-inspiring-cinematic-background-music-27107.mp3",
    video: null,
    body: LOREM,
  },
  {
    id: "a2",
    slug: "gold-price-targets-from-five-bullion-desks",
    title: "Gold Price Targets From Five Bullion Desks: A Comparative Read",
    dek: "Five major bullion desks have quietly raised year-end targets. We compare their models — and where they disagree.",
    category: "metals",
    author: "mf",
    image: IMG.gold1,
    publishedAt: "2025-07-04T08:00:00Z",
    readTime: 6,
    featured: true,
    tags: ["Gold", "Bullion", "Forecasts"],
    audio: null,
    video: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    body: LOREM,
  },
  {
    id: "a3",
    slug: "strait-of-hormuz-shipping-under-new-rules",
    title: "Strait of Hormuz: Shipping Under a New Rulebook",
    dek: "Iran-approved transit corridors are reshaping global crude flows. Insurance premiums are already telling the story.",
    category: "geopolitical",
    author: "mf",
    image: IMG.geo1,
    publishedAt: "2025-07-03T22:45:00Z",
    readTime: 9,
    featured: true,
    tags: ["Oil", "Iran", "Shipping"],
    audio: null,
    video: null,
    body: LOREM,
  },
  {
    id: "a4",
    slug: "dividend-aristocrats-in-a-choppy-tape",
    title: "Dividend Aristocrats in a Choppy Tape",
    dek: "When momentum fails, cash flow rules. A statistical look at the 25 best defensive names for the next drawdown.",
    category: "markets",
    author: "mf",
    image: IMG.markets2,
    publishedAt: "2025-07-03T19:10:00Z",
    readTime: 7,
    tags: ["Dividends", "Equities", "Defensives"],
    body: LOREM,
  },
  {
    id: "a5",
    slug: "the-bail-in-playbook-what-depositors-should-know",
    title: "The Bail-In Playbook: What Depositors Should Know",
    dek: "Post-2013, deposit haircuts moved from theoretical to legal. Here is how modern bail-in frameworks actually function.",
    category: "commentary",
    author: "mf",
    image: IMG.markets3,
    publishedAt: "2025-07-03T14:30:00Z",
    readTime: 11,
    tags: ["Banks", "Depositors", "Regulation"],
    audio: "https://cdn.pixabay.com/download/audio/2023/06/12/audio_cdd8e11f89.mp3?filename=lofi-study-112191.mp3",
    body: LOREM,
  },
  {
    id: "a6",
    slug: "silver-technicals-and-the-64-dollar-line",
    title: "Silver Technicals and the $64 Line",
    dek: "Positioning, structure, and open interest all point to the same level. What happens if we break it?",
    category: "metals",
    author: "mf",
    image: IMG.gold2,
    publishedAt: "2025-07-03T11:20:00Z",
    readTime: 5,
    tags: ["Silver", "Technicals"],
    body: LOREM,
  },
  {
    id: "a7",
    slug: "europes-economic-suicide-a-contrarian-read",
    title: "Europe's Economic Suicide: A Contrarian Read",
    dek: "Energy costs, demographic drag, and regulatory overload — a look at whether the continent can reverse course.",
    category: "geopolitical",
    author: "mf",
    image: IMG.geo2,
    publishedAt: "2025-07-03T08:05:00Z",
    readTime: 10,
    tags: ["Europe", "Energy", "Demographics"],
    body: LOREM,
  },
  {
    id: "a8",
    slug: "the-copper-shortage-nobody-priced-in",
    title: "The Copper Shortage Nobody Priced In",
    dek: "Electrification demand meets a decade of underinvestment. Inventories at the LME tell a story worth pausing on.",
    category: "metals",
    author: "mf",
    image: IMG.gold3,
    publishedAt: "2025-07-02T22:00:00Z",
    readTime: 7,
    tags: ["Copper", "Supply", "Electrification"],
    body: LOREM,
  },
  {
    id: "a9",
    slug: "unemployment-and-the-long-duration-jobless",
    title: "Unemployment and the Long-Duration Jobless",
    dek: "Long-duration unemployment is now above 1.8M. The headline rate no longer captures what is happening.",
    category: "economics",
    author: "mf",
    image: IMG.markets4,
    publishedAt: "2025-07-02T18:40:00Z",
    readTime: 6,
    tags: ["Labor", "Jobless"],
    body: LOREM,
  },
  {
    id: "a10",
    slug: "data-centers-and-the-blackstone-retreat",
    title: "Data Centers and the Blackstone Retreat",
    dek: "A $12B campus is stalling. What the largest private allocator's cold feet may say about the AI capex cycle.",
    category: "technology",
    author: "mf",
    image: IMG.markets5,
    publishedAt: "2025-07-02T14:00:00Z",
    readTime: 8,
    tags: ["AI", "Data Centers", "Blackstone"],
    body: LOREM,
  },
  {
    id: "a11",
    slug: "wealth-tax-thresholds-drift-downward",
    title: "Wealth Tax Thresholds Drift Downward",
    dek: "First $1B, now $50M — the political ratchet mechanism has never worked in reverse. A brief history.",
    category: "politics",
    author: "mf",
    image: IMG.geo3,
    publishedAt: "2025-07-02T10:00:00Z",
    readTime: 5,
    tags: ["Tax", "Policy"],
    body: LOREM,
  },
  {
    id: "a12",
    slug: "an-accelerator-metric-for-market-chaos",
    title: "An Accelerator Metric for Market Chaos",
    dek: "A composite indicator — volatility, breadth, cross-asset correlation — that flagged 2018, 2020, and 2022.",
    category: "research",
    author: "mf",
    image: IMG.markets6,
    publishedAt: "2025-07-01T21:30:00Z",
    readTime: 12,
    tags: ["Volatility", "Composite", "Signals"],
    audio: "https://cdn.pixabay.com/download/audio/2022/10/25/audio_946bc7ba33.mp3?filename=jazz-lounge-124261.mp3",
    body: LOREM,
  },
  {
    id: "a13",
    slug: "russia-poland-and-nato-tripwire-logic",
    title: "Russia, Poland, and NATO Tripwire Logic",
    dek: "A quiet reading of the border escalations and why the tripwire doctrine is being stress-tested in 2025.",
    category: "geopolitical",
    author: "mf",
    image: IMG.geo4,
    publishedAt: "2025-07-01T17:15:00Z",
    readTime: 9,
    tags: ["NATO", "Russia", "Poland"],
    body: LOREM,
  },
  {
    id: "a14",
    slug: "medicare-in-2025-a-comprehensive-review",
    title: "Medicare in 2025: A Comprehensive Review",
    dek: "Recent changes to Medigap and Medicare Advantage — what beneficiaries need to know before enrollment.",
    category: "commentary",
    author: "mf",
    image: IMG.markets3,
    publishedAt: "2025-06-30T14:00:00Z",
    readTime: 14,
    tags: ["Medicare", "Healthcare"],
    body: LOREM,
  },
  {
    id: "a15",
    slug: "presidential-etiquette-and-market-signaling",
    title: "Presidential Etiquette and Market Signaling",
    dek: "How executive tone at press conferences moves 10-year yields — a look at 20 years of data.",
    category: "politics",
    author: "mf",
    image: IMG.geo5,
    publishedAt: "2025-06-29T10:00:00Z",
    readTime: 6,
    tags: ["Politics", "Yields"],
    body: LOREM,
  },
  {
    id: "a16",
    slug: "the-least-dangerous-places-worlds-at-war",
    title: "The Least Dangerous Places: Worlds at War",
    dek: "A strategic guide to unconventional safe havens and citizenship portfolios in a fragmenting order.",
    category: "research",
    author: "mf",
    image: IMG.geo5,
    publishedAt: "2025-06-28T12:00:00Z",
    readTime: 15,
    tags: ["Sovereignty", "Safe Havens"],
    body: LOREM,
  },
];

export const FEEDS = [
  { source: "Reuters Markets", time: "14m", title: "Fed's Bostic sees one rate cut in 2025 as inflation lingers" },
  { source: "WSJ", time: "38m", title: "Treasury sees strong demand at 10-year auction despite yield rise" },
  { source: "Bloomberg", time: "1h", title: "Gold ETFs post third consecutive week of inflows" },
  { source: "FT", time: "2h", title: "China quietly diversifies FX reserves further from USD" },
  { source: "Kitco", time: "3h", title: "Silver open interest hits multi-year high on Comex" },
  { source: "OilPrice", time: "4h", title: "Brent premium widens as Hormuz reroutes take effect" },
];

export const getArticleBySlug = (slug) => ARTICLES.find((a) => a.slug === slug);
export const getArticlesByCategory = (cat) => ARTICLES.filter((a) => a.category === cat);
export const getAuthor = (id) => AUTHORS.find((a) => a.id === id) || AUTHORS[0];
export const getCategory = (slug) => CATEGORIES.find((c) => c.slug === slug) || CATEGORIES[0];
